import { compile } from "html-to-text";


export function convertHtmlToPlainText(html: string | null | undefined): string | null {
  if (html === null || html === undefined) {
    return null;
  }
  const convert = compile({
    wordwrap: false
  });
  return convert(html, {
    selectors: [
      { selector: 'p', options: { wordwrap: false, leadingLineBreaks: 1, trailingLineBreaks: 1 } },
      { selector: 'a', options: { wordwrap: false, hideLinkHrefIfSameAsText: true, linkBrackets: ['[', ' ]'] } },
    ]
  });
}
